import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { postInitiateLinking } from 'routes/toiplusprimeshow/redux';
import { getSsoidAndTicket, fireGA4WithDataObject } from 'utils/common';
import SubscriptionModal from './GoogleSubscriptionModalPopUp';
import GoogleReactPortal from './GoogleModalPortal';
import s from './SubscriptionButton.scss';
import { fetchUserSubscriptionStatusFromApi } from 'utils/primeUtil';
interface ISubscriptionStrip {
  isWapView: boolean;
  alreadylinkedCallback: (param: any) => {};
  alreadyLinked: boolean;
  children: any;
  type: string;
  userPrcData?: any;
}

const SubscriptionButton = ({
  isWapView,
  alreadylinkedCallback,
  alreadyLinked,
  children,
  type,
  userPrcData,
}: ISubscriptionStrip) => {

  const [openModal, setOpenModal] = useState(false);

  const alreadylinkedCallbackHandler = () => {
    if (!(document.getElementById('portal-modal')?.getAttribute('openmodal') === 'true')) {
      if (alreadyLinked) {
        setOpenModal(true);
      } else {
        setOpenModal(false);
      }
    }
  }

  useEffect(() => {
    if (!alreadyLinked) {
      fireGA4WithDataObject({
        event: 'subs_with_google',
        steps_name: 'view',
        page_template: window.location.href.indexOf('articleshow') > -1 ? 'Articleshow' : 'TOI Home',
        prime_user: '5',
      });
    }
  }, []);

  const closeModalHandler = () => {
    setOpenModal(false);
    document.getElementById('portal-modal')?.setAttribute('openmodal', 'false');
  }

  const linkSubsFlow = () => {
   
    let page_template = 'TOI Home'
    if (window.location.href.indexOf('articleshow') > -1) {
      page_template = 'Articleshow'
    } else if (window.location.href.indexOf('liveblog') > -1) {
      page_template = 'LiveBlog'
    }
    (self as any).SWG.push(async (subscriptions: any) => {
      try {
        console.log('getSsoidAndTicket()===ssoId===>', getSsoidAndTicket()?.ssoId)
        const result = await subscriptions.linkSubscription({
          publisherProvidedId: getSsoidAndTicket()?.ssoId,
        });
        console.log('result==>', result);
        if (result?.success) {
          fetchUserSubscriptionStatusFromApi(userPrcData)
            .then(async (data: any) => {
              const postInitiateLinkingData = await postInitiateLinking({ isWapView, token: data?.data?.token });
              console.log(
                'succesfully passed data to backend and google',
                postInitiateLinkingData,
              );
              if (postInitiateLinkingData?.data) {
                alreadylinkedCallback(true);
              }
            })
        }
      } catch (e) {
        console.log(e);
        fireGA4WithDataObject({
          event: 'subs_with_google',
          steps_name: 'cta_click_fail',
          page_template: page_template,
          prime_user: '5'
        });
      }
    });
    fireGA4WithDataObject({
      event: 'subs_with_google',
      steps_name: 'cta_click_success',
      page_template: page_template,
      prime_user: '5'
    });
  };

  const linkSubsClickHandler = (e: React.MouseEvent) => {
    // setOpenModal(true);
    e.preventDefault();
    e.stopPropagation();
    alreadylinkedCallbackHandler();
    let page_template = 'TOI Home'
    if (window.location.href.indexOf('articleshow') > -1) {
      page_template = 'Articleshow'
    } else if (window.location.href.indexOf('liveblog') > -1) {
      page_template = 'LiveBlog'
    }
    fireGA4WithDataObject({
      event: 'subs_with_google',
      steps_name: 'cta_click',
      page_template: page_template,
      prime_user: '5'
    });
    if (!(window as any).SWG && !alreadyLinked) {
      const swgSrc = 'https://news.google.com/swg/js/v1/swg.js';
      const swgScript = document.createElement('script');

      swgScript.src = swgSrc;
      swgScript.async = true;

      swgScript.setAttribute('subscriptions-control', 'manual');
      document.body.appendChild(swgScript);

      // eslint-disable-next-line func-names
      swgScript.onload = function () {
        linkSubsFlow();
      };
    } else if ((window as any).SWG && !alreadyLinked) {
      linkSubsFlow();
    }
  };

  return <div>
    {type === 'button-v2' && (
      <>
        <SubscriptionBtn disabled={alreadyLinked} onMouseDown={linkSubsClickHandler}>Link subscription <img src="https://static.toiimg.com/photo/109346506.cms" alt="google logo" /></SubscriptionBtn>
      </>
    )
    }
    {type === 'button-v1' && (
      <div
        className={`subs-button-wrapper ${s.subscriptionWrapper} ${alreadyLinked ? s.disabled : ''
          }`}
      >
        <div
          className={`${s.subscriptionButton} ${alreadyLinked ? s.disabled : ''
            }`}
          onClick={e => linkSubsClickHandler(e)}
        >
          {!alreadyLinked ? (
            <>
              Link subscription
              <span>
                <img
                  src="https://static.toiimg.com/photo/101657254.cms"
                  alt=""
                />
              </span>
            </>
          ) : (
            <span>Subscription Linked</span>
          )}
        </div>
      </div>
    )
    }
    {type !== 'button-v2' && type !== 'button-v1' && <div>
      <div
        className={s.subscriptionButtonv2}
        onClick={e => linkSubsClickHandler(e)}
      >
        {children}
      </div>
    </div>
    }
    <GoogleReactPortal wrapperId="portal-modal" openModal={openModal}>
      <SubscriptionModal closeFn={closeModalHandler} openModal={openModal} isWapView={isWapView} />
    </GoogleReactPortal>
  </div>
}

export const SubscriptionBtn = styled.span`
    background: #fff;
    border: 1px solid #D8D7D7;
    padding: 8px 12px;
    height: 34px;
    display: flex;
    border-radius: 4px;
    align-items: center;
    cursor: pointer;
    text-transform: capitalize;
    opacity: ${(props: any) =>
    props.disabled ? 0.5 : 1};
      cursor: ${(props: any) =>
    props.disabled ? 'none' : 'all'};
    & {
      font-size: 14px;
      font-weight: 600;
      text-transform: capitalize;
      line-height: 32px;
      display: flex;
      align-items: center;
      @media screen and (min-width: 1180px) and (max-width:1366px) {
        font-size: 12px;
      }
      & img {
        display: inline-block;
        height: 22px;
        margin-left: 8px;
      }
    }

`;

export const SubscriptionImg = styled.img`
    
`;

export default SubscriptionButton;


